import { Type } from "class-transformer";
import { ChangeSummaryEntry } from "./ChangeSummaryEntry";

export class ChangeSummary {
    //netgen start
    lastId = 0;
    @Type(() => ChangeSummaryEntry)
    changes: ChangeSummaryEntry[];
    //netgen end

    hasType(type: string): boolean {
        return this.changes.some(x => x.entityType === type);
    }

    hasAnyType(types: string[]): boolean {
        return this.changes.some(x => types.includes(x.entityType));
    }
}
